
<ion-row tappable (click)="goTo('account')" [ngClass]="{'selectedButton': menuData?.route === 'account'}">
  <ion-col class="button-icon">
    <div class="icon-account"></div>
  </ion-col>
  <ion-col class="button-label">
    <tidy-text [body]="'Account'" />
  </ion-col>
</ion-row>
<ion-row tappable (click)="help()">
  <ion-col class="button-icon">
    <div class="icon-help"></div>
  </ion-col>
  <ion-col class="button-label">
    <tidy-text [body]="'Help'" />
  </ion-col>
</ion-row>
